import { Mediator } from '@spotahome/soyuz-mediator';
import { trans } from '@spotahome/soyuz/client';

import { CHANNELS } from '../utils/constants';

import { DSIcon } from '../../../base';

import VerificationInfo from './VerificationInfo';

import styles from './PropertyVerifiedModal.module.scss';

const PropertyVerifiedModalContent = ({
  homechecker = null,
  verificationDate = null
}) => (
  <>
    <p className={styles['property-verified-modal__section']}>
      {trans('property_verified.modal.description')}
    </p>

    <VerificationInfo
      className={styles['property-verified-modal__section']}
      homechecker={homechecker}
      verificationDate={verificationDate}
    />

    <div className={styles['property-verified-modal__section']}>
      <div className={styles['property-verified-modal__section-content']}>
        <h5 className={styles['property-verified-modal__conditions-title']}>
          {trans('property_verified.modal.conditions1')}
        </h5>
        <ul className={styles['property-verified-modal__conditions-list']}>
          <li>{trans('property_verified.modal.conditions1.item1')}</li>
          <li>{trans('property_verified.modal.conditions1.item2')}</li>
        </ul>
      </div>

      <div>
        <h5 className={styles['property-verified-modal__conditions-title']}>
          {trans('property_verified.modal.conditions2')}
        </h5>
        <p>{trans('property_verified.modal.conditions2.item1')}</p>
      </div>
    </div>
  </>
);

const openPropertyVerifiedModal = ({
  homechecker = null,
  verificationDate = null
} = {}) => {
  Mediator.publish(CHANNELS.OPEN_INFORMATION_MODAL, {
    title: (
      <>
        <DSIcon name="check_circle_transparent" size="ml" />
        <br />
        {trans('property_verified.modal.title')}
      </>
    ),
    body: (
      <PropertyVerifiedModalContent
        homechecker={homechecker}
        verificationDate={verificationDate}
      />
    ),
    fullscreenOnMobile: true
  });
};

export default openPropertyVerifiedModal;
